import axios from './configAxiosStaff';

export const putUser = async (adressId, requestData) => {
	return axios.put(`/${adressId}/update/`, requestData);
};
